import { Itemimage } from "store/serializers/itemimage"
import model from "./itemimage"

export default {
  active: "boolean",
  at_event_ticketing: "boolean",
  auction_id: "number",
  cost: "number",
  description: "string",
  full_description: "string",
  high_bid: "number",
  raffle_price: "number",
  raffle_qty: "number",
  bid_increment: "number",
  buy_price: "number",
  high_bid_id: "number",
  high_bid_user_id: "number",
  item_id: "number",
  item_type: "string",
  item_qty: "number",
  marketplace_provider_id: "number",
  reserve: "number",
  sort_position: "number",
  sponsor_id: "number",
  status: "number",
  tickets_purchased: "number",
  value: "number",
  value_display: "number",

  is_raffle: "boolean",
  live_auction: "boolean",

  marketplace_provider: "string",
  paid: "boolean",
  published: "boolean",
  refunded: "boolean",

  categories: "array",
  tags: "array",

  high_bid_data: "object"
}



// WEBPACK FOOTER //
// ./src/store/models/item.js